module.exports = __webpack_public_path__ + "static/media/concert.1693fdb9.png";